import React from 'react'
import { object } from 'prop-types'
import { Routes, routeWithParams } from '../../util/routes'

import AUTHOR_FALLBACK from '../../images/default-author-icon.png'
import * as Styled from './styles/AuthorBlock.styles'

const AuthorDetails = ({ data }) => {
  const isGuestAuthor = data.type === 'guest_author'
  const author = data.data

  const Details = () => (
    <>
      <Styled.TextItem>
        <Styled.Heading>Author</Styled.Heading>
        <Styled.Body>{author.name?.text ?? ''}</Styled.Body>
      </Styled.TextItem>
      {author.title && (
        <Styled.TextItem>
          <Styled.Heading>Title</Styled.Heading>
          <Styled.Body>{author.title?.text ?? ''}</Styled.Body>
        </Styled.TextItem>
      )}
    </>
  )

  return !isGuestAuthor && data.uid ? (
    <Styled.Link href={routeWithParams(Routes.STAFF_DETAIL, { uid: data.uid })}>
      <Details />
    </Styled.Link>
  ) : (
    <Details />
  )
}

const AuthorBlock = ({ data, bottomPaddingAdjustment }) => {
  if (!data) {
    return null
  }

  const author = data.data

  return (
    <Styled.AuthorBlock bottomPaddingAdjustment={bottomPaddingAdjustment}>
      <Styled.ContainerRow>
        {author.author_image?.url && (
          <Styled.Photo
            src={data.author_image?.url ?? AUTHOR_FALLBACK}
            alt={author.author_image?.alt ?? ''}
          />
        )}
        {!author.author_image?.url && (
          <Styled.Photo as="img" alt="" src={AUTHOR_FALLBACK} />
        )}
        <Styled.TextRegion>
          <AuthorDetails data={data} />
        </Styled.TextRegion>
      </Styled.ContainerRow>
    </Styled.AuthorBlock>
  )
}

AuthorBlock.propTypes = {
  data: object,
}

export default AuthorBlock
